import { bootstrapApplication } from '@angular/platform-browser'
import { provideRouter } from '@angular/router'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { DatePipe } from '@angular/common'

import { AppComponent } from './app/app.component'
import { routes } from './app/app.routes'
import { authInterceptor } from './app/common/api/interceptors/auth.interceptor'

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    DatePipe
  ]
}).catch(err => console.error(err))
